import produce from "immer";
import {
  ADD_SCOPE_GROUP_ERROR,
  ADD_SCOPE_GROUP_REQUEST,
  ADD_SCOPE_GROUP_SUCCESS,
  DELETE_SCOPE_GROUP_ERROR,
  DELETE_SCOPE_GROUP_REQUEST,
  DELETE_SCOPE_GROUP_SUCCESS,
  GET_ALL_SCOPE_GROUPS_ERROR,
  GET_ALL_SCOPE_GROUPS_REQUEST,
  GET_ALL_SCOPE_GROUPS_SUCCESS,
  UPDATE_SCOPE_GROUP_ERROR,
  UPDATE_SCOPE_GROUP_REQUEST,
  UPDATE_SCOPE_GROUP_SUCCESS,
} from "./groupsActions";

const initialState = {
  scopeGroups: [],
  isFetchingScopeGroups: false,
  isUpdatingScopeGroups: false,
  scopeGroupsError: null,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_SCOPE_GROUPS_REQUEST:
      return produce(state, (draftState) => {
        draftState.isFetchingScopeGroups = true;
      });
    case GET_ALL_SCOPE_GROUPS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.scopeGroups = payload;
        draftState.isFetchingScopeGroups = false;
      });
    case GET_ALL_SCOPE_GROUPS_ERROR:
      return produce(state, (draftState) => {
        draftState.isFetchingScopeGroups = false;
        draftState.scopeGroupsError = payload;
      });
    case ADD_SCOPE_GROUP_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = true;
      });
    case ADD_SCOPE_GROUP_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        const newGroups = draftState.scopeGroups.slice();
        newGroups.push(payload);
        draftState.scopeGroups = newGroups;
      });
    case ADD_SCOPE_GROUP_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        draftState.scopeGroupsError = payload;
      });
    case UPDATE_SCOPE_GROUP_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = true;
      });
    case UPDATE_SCOPE_GROUP_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        draftState.scopeGroups = draftState.scopeGroups.map((group) =>
          group.id === payload.id ? payload : group
        );
      });
    case UPDATE_SCOPE_GROUP_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        draftState.scopeGroupsError = payload;
      });
    case DELETE_SCOPE_GROUP_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = true;
      });
    case DELETE_SCOPE_GROUP_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        draftState.scopeGroups = draftState.scopeGroups.filter(
          (group) => group.id !== payload
        );
      });
    case DELETE_SCOPE_GROUP_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdatingScopeGroups = false;
        draftState.scopeGroupsError = payload;
      });
    default:
      return state;
  }
}
